import { Colors } from '@zapier/design-system';
import { css, keyframes } from '@emotion/core';

const growLine = keyframes`
  from { width: 0; }
`;

const starPopIn = keyframes`
  0% { transform: scale(2); }
  100% { transform: none; }
`;

const Styles = {
  active: css`
    border: 3px solid ${Colors.StatusSuccessStronger};
    height: 75px;
    width: 75px;
    position: relative;
    @media screen and (min-width: 760px) {
      height: 93px;
      width: 93px;
    }
  `,
  completed: css`
    border-width: 3px;
  `,
  levelPerksContent: css`
    margin-bottom: 1em;
    text-align: center;
  `,
  levelPerksList: css`
    line-height: 1.95em;
    list-style: inside disc;
    margin: 0.5em 0.5em 25px;
    text-align: left;
  `,
  levelPerksListItem: css`
    padding-left: 1.5em;
    text-indent: -1.5em;
  `,
  progress: (isCompleted: boolean) => css`
    background-image: radial-gradient(circle, #edf1f3 12%, transparent 12%);
    background-position: 0 50%;
    background-repeat: repeat-x;
    background-size: 32px 32px;
    flex: 1 1;
    height: 50px;
    margin: ${isCompleted ? '0' : '0 1em'};
    position: relative;
    transform: translateY(1em);
  `,
  progressBar: (index: number) => css`
    :before {
      width: ${index === 1 ? '33%' : index === 2 ? '66%' : '100%'};
    }
  `,
  star: css`
    animation: ${starPopIn} 0.75s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    background-color: ${Colors.StatusSuccessStronger};
    border-radius: 50%;
    color: ${Colors.PrimeWhite};
    padding: 3px 4px 4px;
    position: absolute;
    right: -4px;
    top: 0;
    will-change: transform;
  `,
  starIcon: css`
    display: block;
    height: 15px;
    width: 15px;
  `,
  tier: css`
    cursor: pointer;
    position: relative;
    text-align: center;
    :hover > .tier-tooltip {
      opacity: 1;
      top: 0;
      z-index: 100;
      visibility: visible;
    }
  `,
  tierGraph: css`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1em;
    padding: 1em 0px;
    position: relative;

    :before {
      content: '';
      position: absolute;
      top: calc(50% + 0.5em);
      left: 0;
      height: 1em;
      width: 0;
      animation: ${growLine} 1.5s cubic-bezier(0.19, 1, 0.22, 1);
      animation-delay: 1.5s;
      animation-fill-mode: both;
      background-color: ${Colors.PrimeWhite};
      background-image: linear-gradient(180deg, transparent 50%, #f1f4f5 50%);
      background-position: 0 calc(50% - 2px);
      background-repeat: no-repeat;
      background-size: 100% 8px;
    }

    @media (max-width: 900px) {
      overflow-x: auto;
    }
  `,
  tooltip: css`
    background-color: ${Colors.PrimeWhite};
    border: 1px solid ${Colors.GrayWarm4};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    opacity: 0;
    padding: 2em 1em 1em;
    position: absolute;
    left: 50%;
    top: 0%;
    text-align: center;
    transform: translate(-50%, -100%);
    transition: opacity 0.25s ease-out, top 0.25s ease-out;
    visibility: hidden;
    width: 290px;
    will-change: opacity, top;

    &.first {
      left: 0;
      transform: translateY(-100%);
      :before,
      :after {
        left: 22px;
        transform: none;
      }
    }
    &.last {
      left: auto;
      transform: translateY(-100%);
      right: 0;
      :before,
      :after {
        transform: none;
        left: auto;
        right: 22px;
      }
    }
  `,
  tooltipTrophy: css`
    height: 66px;
    width: 64px;
    margin: 0px auto 10px;
  `,
  trophy: css`
    background-color: ${Colors.PrimeWhite};
    border-radius: 50%;
    position: relative;
    height: 60px;
    width: 60px;
    display: flex;
    justify-content: center;
    margin-top: 10px;
    @media screen and (min-width: 760px) {
      height: 75px;
      width: 75px;
    }
  `,
  trophyInactiveBorder: css`
    border: 1px solid ${Colors.GrayWarm4};
  `,
};

export default Styles;
